import React from 'react';
import GeckoTableCellBase from '../_base.jsx';
import { GeckoAvatar } from '../../../../';

class GeckoTableCellName extends GeckoTableCellBase {
  render() {
    return (
      <div>
        <GeckoAvatar name={this.renderValue()} />
        &nbsp;
        {this.renderValue()}
      </div>
    );
  }
}

export default GeckoTableCellName;
